

export default class CreateAccountValid{

    public static checkCreateAccount = (tempName: string, tempCompany: string, tempEmail: string, tempPhone: string, errorMsg: string) =>{
        const isValidEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/g;
        const isValidPhoneNumber = /^(?:[+\d].*\d|\d)$/g;
        if(tempEmail === undefined || tempEmail === ""){errorMsg = errorMsg + "Please enter email.\n 請輸入電子郵件。 \n"}
        else if(!tempEmail.match(isValidEmail)){errorMsg = errorMsg + "Please check email format.\n 請檢查電子郵件格式。 \n"}
        if(tempCompany === undefined || tempCompany === ""){errorMsg = errorMsg + "Please enter company.\n 請輸入公司名稱。 \n"}
        if(tempPhone === undefined || tempPhone === ""){errorMsg = errorMsg + "Please enter phone number.\n 請輸入電話號碼。 \n"}
        else if(!tempPhone.match(isValidPhoneNumber)){errorMsg = errorMsg + "Please check phone number format.\n 電話號碼應為數字。 \n"}
        return errorMsg
    }
}